/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/api-v2-client";
import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest, AuditReportsCreateOneBaseAugmentedAodRulesMutationResponse, AuditReportsCreateOneBaseAugmentedAodRules401, AuditReportsCreateOneBaseAugmentedAodRules403 } from "../models/AuditReportsCreateOneBaseAugmentedAodRules";

export function getAuditReportsCreateOneBaseAugmentedAodRulesUrl() {
  const res = { method: 'POST', url: `/audit-reports/v1/aod-rules` as const }
  return res
}

/**
 * @summary Create a single AodRule
 * {@link /audit-reports/v1/aod-rules}
 */
export async function auditReportsCreateOneBaseAugmentedAodRules(data: AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest, config: Partial<RequestConfig<AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<AuditReportsCreateOneBaseAugmentedAodRulesMutationResponse, ResponseErrorConfig<AuditReportsCreateOneBaseAugmentedAodRules401 | AuditReportsCreateOneBaseAugmentedAodRules403>, AuditReportsCreateOneBaseAugmentedAodRulesMutationRequest>({ method : "POST", url : getAuditReportsCreateOneBaseAugmentedAodRulesUrl().url.toString(), data : requestData, ... requestConfig })
  return res.data
}